import React from 'react';
import { Link } from 'react-router-dom';

function SuspensionInfo({ suspension, setShowGreeniaAI }) {
  return (
    <div className="w-75 ms-auto mb-3">
      <div className="bg-muted border border-dark p-3 rounded-3 shadow">
        <h5 className="fs-6">Nuova Sospensione Creata</h5>
        <hr />
        <div>
          <div className="row">
            <div className="col-12">
              <p>
                <small>
                  Per vedere le informazioni della sospensione premi il pulstante sotto.
                </small>
              </p>
            </div>
            <div className="col-12">
              <Link className="btn btn-dark" onClick={() => setShowGreeniaAI(false)} to={`/after-sale/purchase/suspension/${suspension.suspensionId}`}>
                Visualizza Sospensione
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SuspensionInfo;
